export default __webpack_public_path__ + "static/media/new-article-bottom.a6cd1e3c.svg";